<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-edit">
    <form data-vv-scope="ProfesseurClasseMatiere" @submit.prevent="ProfesseurClasseMatiere_validate">
      <vx-card ref="filterCard" :title="$t('matter_by_teachers')" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
        <div class="vx-row">
          <div class="vx-col w-full">
            <p > {{ $t('Employee') }} <b style="color: #ff6141">*</b> </p>
            <v-select 
              :options="postEmployes"
              @search="getPostEmploye" 
              :clearable="true" 
              :getOptionLabel="getOptionLabel"
              v-model="postEmploye"
              class="w-full" name="postEmploye" v-validate="'required'"/>                
            <span class="text-danger">{{ errors.first('ProfesseurClasseMatiere.postEmploye') }}</span>
          </div>

          <div v-if="postEmploye" class="vx-col w-full mt-3">
            <p> {{ $t('matter') }} <b style="color: #ff6141">*</b> </p>
            <v-select 
              multiple
              :closeOnSelect="false"
              :options="matieres"
              @search="getMatiere" 
              :clearable="true" 
              label="libelle"
              v-model="input_matieres"
              class="w-full" name="classeMatiere" v-validate="'required'"/>                
            <span class="text-danger">{{ errors.first('ProfesseurClasseMatiere.classeMatiere') }}</span>
          </div>
          
        </div>
      </vx-card>

      <div :key="indextr" v-for="(tr, indextr) in input_matieres">
        <matiereClasse
          :matiere ="tr"
          :classeMatiere ="classeMatieres"
          :matiereObject ="matiereObject"
          :verification ="verification"
        />
        <span v-if="erreurs[indextr]" class="text-danger">Les classes de {{ tr.libelle }} sont requises</span>

      </div>

          <vs-button  class="mt-4" color="success" type="border" icon-pack="feather" icon="icon-save" @click="ProfesseurClasseMatiere_validate">{{ $t("Submit") }}</vs-button>
        
    </form>
  </div>
</template>

<script>
let base_self = ''
// const input_tempon = {
//   id: null, 
//   libelle: '',
//   salle: [],
//   classeMatiere: '',
//   postEmploye: ''
// }

import { Validator } from 'vee-validate'

import matiereClasse from './matiere.vue'

export default {
  components: { matiereClasse },
  data () {
    return {
      label: ['employe', 'full_name'],
      postEmploye: '',
      input_matieres: [],
      input: [],
      paramPostEmploye: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: [],
          postes__professeur: true
        }
      },
      paramMatiere: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: []
        },
        orderby: ['libelle']
      },
      paramClasse: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: [],
          is_active: true,
          niveau__is_active: true
        },
        orderby: ['ordre']
      },
      paramClasseMatiere: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: []
        }
      },
      paramSalle: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: [],
          is_active: true,
          classe__is_active: true,
          classe__niveau__niveauTypePartitions__anneeScolaire__id: this.$store.state.anneeScolaire.id,
          classe__niveau__is_active: true
        },
        orderby: ['ordre'],
        exclude: { code: 'Attente' }
      },
      postEmployes: [],
      classeMatieres: [],
      matieres: [],
      salleGene: {},
      classeCourantGlobale: '',
      matiereObject: {},
      verification: false,
      erreurs: [],
      error: false
    }
  },
  watch: {
    input_matieres () {
      // base_self.generateProfesseurClasseMatiere()
      base_self.input_MatieresChange()
    }
    // postEmploye () {
    //   base_self.generateProfesseurClasseMatiere()
    // },
    // classeMatieres () {
    //   base_self.generateProfesseurClasseMatiere()
    // },
    // matieres () {
    //   base_self.generateProfesseurClasseMatiere()
    // }
  },
  methods: {

    input_MatieresChange () {
      const keys = Object.keys(this.matiereObject)
      const tampon = {}

      for (let i = 0; i < base_self.input_matieres.length; i++) {
        const element = base_self.input_matieres[i]
        tampon[element.id] = true
        if (!this.matiereObject[element.id]) {
          this.matiereObject[element.id] = []
        } 
      }

      for (let i = 0; i < keys.length; i++) {
        if (!tampon[keys[i]]) {
          delete this.matiereObject[keys[i]]
        }
      }
    },
    getOptionLabel (option) {
      if (typeof option === 'object') {
        const length = this.label.length
        let element = option
        for (let i = 0; i < length; i++) {
          if (!element.hasOwnProperty(this.label[i])) {
            return console.warn(
              `[vue-select warn]: Label key "option.${this.label}" does not` +
              ` exist in options object ${JSON.stringify(option)}.\n` +
              'https://vue-select.org/api/props.html#getoptionlabel'
            )
          }

          element = element[this.label[i]]
        }
          
        // return option['created_at']
        return element
      }
      return option
    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    initSalleForInput (salles, indextr) {
      if (salles.length === 1) {
        base_self.input[indextr].salle = JSON.parse(JSON.stringify(salles))
      }
    },
    getSalleSimple (paramSalle) {
      return new Promise((resolve, reject) => {
        delete paramSalle.filter['libelle__icontains']
        base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, paramSalle)
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((error) => { 
            console.log('error: ', error)
            reject(error)
          })
      })
    },
    getClasseSimple () {
      delete base_self.paramClasse.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Classe`, base_self.paramClasse)
        .then((response) => {
          base_self.classes = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getSalle (search, loading) {
      loading(true)
      const paramSalle = JSON.parse(JSON.stringify(base_self.paramSalle))
      paramSalle.filter['classe__id'] = base_self.classeCourantGlobale.id
      paramSalle.filter['libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, paramSalle)
        .then((response) => {
          base_self.salleGene[base_self.classeCourantGlobale.indextr] = JSON.parse(JSON.stringify(response.data.data))
          
          base_self.initSalleForInput(response.data.data, base_self.classeCourantGlobale.indextr)
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getClasseMatiereSimple () {
      delete base_self.paramClasseMatiere.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}ClasseMatiere`, base_self.paramClasseMatiere)
        .then((response) => {
          base_self.classeMatieres = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getMatiere (search, loading) {
      loading(true)
      base_self.paramClasseMatiere.filter['libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Matiere`, base_self.paramClasseMatiere)
        .then((response) => {
          base_self.matieres = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getMatiereSimple () {
      delete base_self.paramMatiere.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Matiere`, base_self.paramMatiere)
        .then((response) => {
          base_self.matieres = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getPostEmployeSimple () {
      delete base_self.paramPostEmploye.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}PostEmploye`, base_self.paramPostEmploye)
        .then((response) => {
          base_self.postEmployes = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getPostEmploye (search, loading) {
      loading(true)
      base_self.paramPostEmploye.filter['libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}PostEmploye`, base_self.paramPostEmploye)
        .then((response) => {
          base_self.postEmployes = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    ProfesseurClasseMatiere_validate () {
      base_self.$validator.validateAll('ProfesseurClasseMatiere').then(result => {
        if (result) {
          this.validateMatiere().then(() => {
            if (!this.error) {
              base_self.submitData()
              
            }
          })
        }
      })
    },
    validateMatiere () {
      this.error = false
      return new Promise((resolve) => {
        for (let i = 0; i < this.input_matieres.length; i++) {
          const element = this.matiereObject[this.input_matieres[i].id]
          if (!element.length) {
            this.erreurs[i] = true
            this.error = true
          } else {
            this.erreurs[i] = false
          }
        }

        this.erreurs = JSON.parse(JSON.stringify(this.erreurs))
        console.log('this.erreurs: ', this.erreurs)
        resolve(true)
      })
    },
    async submitData () {
      base_self.$vs.loading()
      const array = []
      for (let i = 0; i < this.input_matieres.length; i++) {
        const element = this.input_matieres[i]
        const inp = this.matiereObject[element.id]
        for (let j = 0; j < inp.length; j++) {
          const elt = {}
          elt.salle = inp[j].classe.salle.id
          elt.libelle = `${this.postEmploye.employe.full_name} - ${element.libelle} - ${inp[j].classe.salle.libelle}`
          elt.postEmploye = this.postEmploye.id
          elt.classeMatiere = inp[j].id
            
          const param = JSON.parse(JSON.stringify(base_self.$store.state.paramProfesseurClasseMatiere))
          param.filter['salle__id'] = elt.salle
          param.filter['postEmploye__id'] = elt.postEmploye
          param.filter['classeMatiere__id'] = elt.classeMatiere
          const response = await base_self.$http.post(`${base_self.$store.state.route_for_esm}ProfesseurClasseMatiere`, param)
            .catch((error) => { 
              console.log('error: ', error)
              base_self.$vs.loading.close()
            })

          console.log('matiereObject: ', response.data.data)

          if (!response.data.data.length) {
            
            array.push(elt)
          }
        }
  
      }
      const data = {
        many: true,
        data: array
      }
      
      base_self.$http.post(`${base_self.$store.state.route_for_esm}ProfesseurClasseMatiere`, data)
        .then((response) => { 
          window.getESM.success(base_self.$t('The_matters_by_class_are_added_successfully'), response)
          base_self.$vs.loading.close()
          base_self.$router.push('/report_cards_management/matter_by_teachers/').catch(() => {})
        })
        .catch((error) => { 
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })
    },
    initValues () {
      /* base_self.input = JSON.parse(JSON.stringify(input_tempon))
      base_self.input1 = JSON.parse(JSON.stringify(input_tempon)) */

      base_self.$validator.errors.clear() 
    }
  },
  created () {
    base_self = this

    base_self.initValues()
    base_self.getPostEmployeSimple()
    base_self.getClasseMatiereSimple()
    base_self.getMatiereSimple()
    base_self.getClasseSimple()

    ///////////////////////////
    const dict = {
      custom: {
        postEmploye: {
          required: base_self.$t('The_Employee_is_required')
        },
        classeMatiere: {
          required: base_self.$t('The_matter_by_class_is_required')
        },
        salle: {
          required: base_self.$t('The_room_is_required')
        }
      }
    }
    Validator.localize('en', dict)
    //////////////////////////
  }
}

</script>